import { client } from "./client";
import { LinkInfo } from "../types/LinkInfo";
import { DietanamnezType } from "types/DietanamnezType";

export type Custom = null | {
  custom_additional_data?: {
    final_screen_additional_content?: {
      additional_text: string;
      button_lable: string;
      button_url?: string;
    },
    css?: string,
    logo?: string,
    replacement1?: string,
    report_is_supliment_visible?: boolean,
    report_title_page_logo?: [{
      logo: string,
      logo_size?: string,
    }],
    report_footer_copyright?: string,
    logo_welcome_size?: string,
    logo_success_registration_size?: string,
    logo_final_size?: string,
    replacement_footer_copyright: string | null,
    selfregistration_report_type: string | undefined,
  };
  custom_генерировать_бад_рацион_при_саморегистрации?: boolean;
  custom_показывать_экран_выявлен_дефицит_потребления?:boolean,
  custom_показывать_экран_рекомендуемая_продукция?:boolean,
  custom_не_запоминать_текущий_экран?:boolean,
  custom_показывать_звездочки_обязательности?:boolean,
  custom_заключение?:string,

  /*Обязательность полей*/
  custom_обязательность_имя?:boolean;
  custom_обязательность_фамилия?:boolean;
  custom_обязательность_отчество?:boolean;
  custom_обязательность_телефон?: boolean;
  custom_обязательность_эл_почта?: boolean;
  custom_обязательность_страна?:boolean;
  custom_обязательность_город?:boolean;
  custom_обязательность_адрес?:boolean;

  /*видимость полей*/
  custom_видимость_имя?:boolean;
  custom_видимость_фамилия?:boolean;
  custom_видимость_отчество?:boolean;
  custom_видимость_телефон?:boolean;
  custom_видимость_эл_почта?:boolean;
  custom_видимость_дата_рождения?:boolean;
  custom_видимость_пол?:boolean;
  custom_видимость_страна?:boolean;
  custom_видимость_город?:boolean;
  custom_видимость_адрес?:boolean;

  custom_возможность_принудительного_завершения_опроса_саморегистрации?:boolean
  custom_показывать_экран_аллергии?: boolean;
  custom_название_поля_эл_почта?: string;
  custom_показывать_кнопку_полный_отчет_на_почту?: boolean;
  custom_показывать_кнопку_скачать_отчет?: boolean;
  custom_есть_вопрос_о_курении_в_саморегистрации?: boolean;
  custom_формированть_в_да_назначение_к_врачам?: boolean;
  custom_дополнительный_текст_отчета?: string | null;
  custom_наименование_проекта?: string | null;
  /*Видимость полей эл. почты и телефона на отдельном экране(для Epharmacy)*/
  custom_показывать_экран_с_вводом_телефона_для_записи_в_имя?: boolean;
  custom_показывать_экран_с_вводом_эл_почты?: boolean;
  custom_города?:
  | null
  | {
    key: string;
    label: string;
  }[];
  custom_страны?:
  | null
  | {
    key: string;
    label: string;
  }[];
};

type RegistrationResponse = {
  key: string;
  consent: string;
  staff: {
    firstname: string;
    lastname: string;
    midname: string | null;
  };
  custom: null | {
    fields: Custom;
  };
  link?: string;
  survey_type: DietanamnezType;
};

type GetContactResponse = {
  contactarea: string;
  da_key: string;
  id: string;
  io: string;
  lite: boolean;
  ret: string;
  public_identifier?: string;
  manufacturers?: { key: string; label: string }[];
  link?: string;
  custom_data: null | {
    logo: string;
    css: string;
    replacement1?: string,
    report_title_page_logo?: [string],
    logo_welcome_size?: string,
    logo_success_registration_size?: string,
    logo_final_size?: string,
    replacement_footer_copyright: string | null,
    selfregistration_report_type: string | undefined,
  };
  country: null | {
    key: string;
  };
};

export async function getRegistrationInfo(token: string): Promise<LinkInfo> {
  const { data } = await client.post<RegistrationResponse>(
    `/${process.env.REACT_APP_API_KEY}t179r/json/v2`,
    {
      parameters: {
        public_id: token,
      },
    },
    {
      headers: {
        Function: "SelfRegistrationCheckId",
      },
    }
  );

  const authorName = [data?.staff?.firstname, data?.staff?.lastname]
    .filter(Boolean)
    .join(" ");

  return {
    consent: data.consent,
    authorName,
    custom: data.custom?.fields || null,
    manufacturers: undefined,
    link: data.link,
    survey_type: data.survey_type,
    country: null,
  };
}

export async function getDietanamnezInfo(
  token: string
): Promise<GetContactResponse> {
  const { data } = await client.post<GetContactResponse>(
    `/${process.env.REACT_APP_API_KEY}t183r/json/v2`,
    {
      parameters: {
        id: token,
      },
    },
    {
      headers: {
        Function: "GetContact",
      },
    }
  );

  return data;
}
